import contentTypeReducer from "./contentTypeReducer";

const contentReducers = {
    content: contentTypeReducer
}

export default contentReducers;